import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Star, Loader2 } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/content/testimonials").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24">
      <div className="max-w-2xl mb-16">
        <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Testimonials</span>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mt-3 mb-4">Voices on their journey.</h1>
        <p className="text-muted-foreground leading-relaxed">Members and practitioners sharing how VoiceMatrix AI fits into their wellness practice.</p>
      </div>
      {items === null ? (
        <div className="py-20 grid place-items-center"><Loader2 className="animate-spin text-primary" strokeWidth={1.5} /></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((t, i) => (
            <div key={t.id} className="rounded-2xl border border-border bg-card p-7 flex flex-col" data-testid={`testimonial-${i}`}>
              <div className="flex gap-1 mb-4">{Array.from({ length: 5 }).map((_, s) => <Star key={s} size={15} className="fill-primary text-primary" strokeWidth={1.5} />)}</div>
              <p className="text-secondary-foreground leading-relaxed flex-1">"{t.text}"</p>
              <div className="mt-6 pt-5 border-t border-border">
                <p className="font-medium text-sm">{t.name}</p>
                {t.plan && <p className="text-xs text-muted-foreground">{t.plan}</p>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
